import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { GroupsPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { customScrollStyles, InfoBlock } from '@gem/ui-kit';

import { IWorkspaceUser } from 'APP/Tasks/workspace/getWorkspaceUsers';
import { List } from 'APP/components/List/List';

import { useWorkspaceMembersListPresenter } from './WorkspaceMembersList.presenter';
import styles from './WorkspaceMembersList.styles.m.css';
import { WorkspaceMembersListItem } from './WorkspaceMembersListItem/WorkspaceMembersListItem';

interface IWorkspaceMembersListProps {
  searchText?: string;
  isShowMemberMenu?: boolean;
  onMemberClick(member: IWorkspaceUser): void;
}

export const WorkspaceMembersList: FC<IWorkspaceMembersListProps> = observer((props) => {
  const { searchText, isShowMemberMenu = true, onMemberClick } = props;
  const presenter = useWorkspaceMembersListPresenter(searchText);
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.container, customScrollStyles.container)}>
      <List
        isLoading={presenter.isLoading}
        hasMore={presenter.hasMore}
        data={presenter.members}
        onEndReached={presenter.loadMore}
        keyExtractor={(member: IWorkspaceUser): string => member.user.id}
        renderItem={(member: IWorkspaceUser): ReactElement => (
          <WorkspaceMembersListItem
            member={member}
            isShowMemberMenu={isShowMemberMenu}
            onMemberRemove={presenter.onMemberRemove}
            onUpdateMemberRole={presenter.onUpdateMemberRole}
            onReloadMembersList={presenter.onReloadMembersList}
            onMemberClick={onMemberClick}
          />
        )}
        ListEmptyComponent={<InfoBlock title={t('no_results_found')} />}
        SpinnerComponent={
          <GroupsPlaceholder
            className={styles.placeholders}
            count={presenter.members.length > 0 ? 2 : 10}
          />
        }
      />
    </div>
  );
});
